/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  ButtonBase,
  Checkbox,
  IconButton,
  ListItem,
  Menu,
  Typography
} from '@material-ui/core'
import MoreIcon from '@material-ui/icons/MoreVert'
import React, { useState } from 'react'

import { addCommaToPrice } from '../../helpers/numbers'
import { persianRegex } from '../../helpers/regex'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { TransactionStatus } from '../../types/walletEnums'
import {
  SelectedTransactions,
  WalletTransaction
} from '../../types/walletTransaction'
import PaymentStatusBox from './PaymentStatusBox'
import ReferencesModal from './ReferencesModal'
import StatusBox from './StatusBox'
import TransactionHistoryModal from './TransactionHistoryModal'
import useStyles from './styles/WalletListTableDesktop.styles'

interface WalletTransactionListTableRowDesktopProps {
  data: WalletTransaction
  selectedTransactions: SelectedTransactions
  setselectedTransactions: React.Dispatch<
    React.SetStateAction<SelectedTransactions>
  >
  checkboxDisabled: boolean
}

export const WalletTransactionListTableRowDesktop: React.FC<
  WalletTransactionListTableRowDesktopProps
> = ({
  data,
  selectedTransactions,
  setselectedTransactions,
  checkboxDisabled
}) => {
  const classes = useStyles()

  const isPersianSenderWallet =
    data.walletID && persianRegex.test(data.correlationID)
  const [referencesModalIsOpen, setreferencesModalIsOpen] =
    useState<boolean>(false)
  const [transactionHistoryModalIsOpen, settransactionHistoryModalIsOpen] =
    useState<boolean>(false)
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null)
  const handleClickMoreOptions = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked

    setselectedTransactions((prev) => {
      const newTotal = isChecked
        ? prev.totalAmountToPay +
          data.amount +
          data.sumOfPenalty -
          data.rewardOfEarlyPayment
        : prev.totalAmountToPay -
          data.amount -
          data.sumOfPenalty +
          data.rewardOfEarlyPayment

      const newTransactionIDs = isChecked
        ? [...prev.transactionIDs, data.transactionID]
        : prev.transactionIDs.filter((id) => id !== data.transactionID)

      return {
        totalAmountToPay: newTotal,
        transactionIDs: newTransactionIDs
      }
    })
  }

  return (
    <div className={[classes.tableRowRoot].join(' ')}>
      <div
        className={
          data?.creditorID ? classes.tableRow : classes.tableRowWithoutCreditor
        }>
        <Checkbox
          color="primary"
          checked={selectedTransactions.transactionIDs.includes(
            data.transactionID
          )}
          onChange={handleCheck}
          disabled={checkboxDisabled}
        />
        <div
          className={classes.nameCell}
          style={
            isPersianSenderWallet ? { fontFamily: 'IranSans' } : undefined
          }>
          <Typography variant="h4">{data.time}</Typography>
        </div>
        {data.creditorID && data.creditorEntity && (
          <div>
            <Typography variant="body1">
              {data.creditorEntity.entityType +
                '-' +
                data.creditorEntity.entityName +
                '-' +
                data.currency}
            </Typography>
          </div>
        )}

        <div>
          <Typography variant="body1">{data.reservationNumber}</Typography>
        </div>
        <div className={classes.flex}>
          <Typography variant="body1">
            {addCommaToPrice(data.amount) +
              ` ${getTranslate(data.currency || '')}`}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">{data.dueDate}</Typography>
        </div>
        <div>
          <Typography
            variant="body1"
            className={
              data.sumOfPenalty > 0
                ? classes.penaltyText
                : data.rewardOfEarlyPayment > 0
                ? classes.rewardText
                : undefined
            }>
            {data.sumOfPenalty > 0
              ? '-' +
                addCommaToPrice(data.sumOfPenalty) +
                ` ${getTranslate(data.currency || '')}`
              : data.rewardOfEarlyPayment > 0
              ? '+' +
                addCommaToPrice(data.rewardOfEarlyPayment) +
                ` ${getTranslate(data.currency || '')}`
              : '0'}
          </Typography>
        </div>
        <div>
          <Typography>
            <StatusBox status={data.status as TransactionStatus} />
          </Typography>
        </div>
        <div>
          <Typography>
            <PaymentStatusBox status={data.paymentStatus} />
          </Typography>
        </div>
        <div>
          <IconButton onClick={handleClickMoreOptions}>
            <MoreIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}>
            <ListItem
              // disabled={data.references.length === 0}
              button
              onClick={() => setreferencesModalIsOpen(true)}>
              {getTranslate('References')}
            </ListItem>
            <ListItem
              // disabled={data.references.length === 0}
              button
              onClick={() => settransactionHistoryModalIsOpen(true)}>
              {getTranslate('Transaction History')}
            </ListItem>
          </Menu>
        </div>
        <TransactionHistoryModal
          isOpen={transactionHistoryModalIsOpen}
          onClose={() => settransactionHistoryModalIsOpen(false)}
          transactionID={data.transactionID}
        />
        <ReferencesModal
          isOpen={referencesModalIsOpen}
          onClose={() => setreferencesModalIsOpen(false)}
          transactionID={data.transactionID}
        />
      </div>
    </div>
  )
}
